import { useMemo } from 'react'
import { HeaderContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { Button } from '@/ui/Button'
import { Popup } from '@/ui/Popup'
import styles from './SortHeader.module.scss'
import commonStyles from './Common.module.scss'

import ArrowDownIcon from '../../assets/arrow-down.svg'

type Props<T> = HeaderContext<T, unknown> & {
    label: string
    buttonLabel: string
}

export const SortHeader = <T,>({ column, table, label, buttonLabel }: Props<T>) => {
    const state = table.getState()

    const isActive = useMemo(() => state.sorting.find((item) => item.id === column.id), [state])

    const handleSortColumn = () => {
        column.toggleSorting(false)
    }

    return (
        <Popup
            triggerComponent={(open: boolean) => (
                <Button
                    size="small"
                    variant="transparent"
                    className={clsx(commonStyles.trigger, { [commonStyles.active]: open || isActive })}
                >
                    {label}
                    <ArrowDownIcon />
                </Button>
            )}
            attachToTrigger
            placement="bottom-end"
            className={commonStyles.popup}
            closeOnClick
        >
            <div className={styles.actionWrapper}>
                <Button variant="transparent" size="small" onClick={handleSortColumn}>
                    {buttonLabel}
                </Button>
            </div>
        </Popup>
    )
}
